export const { REACT_APP_BASE_URL } = process.env;

const request = async (url, options = {}) => {
  const response = await fetch(`${REACT_APP_BASE_URL}${url}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.message || 'Request error');
    error.response = {
      data,
      status: response.status,
    };
    throw error;
  }

  return {
    data,
  };
};

const formRequest = async (url, formData, options = {}) => {
  const response = await fetch(`${REACT_APP_BASE_URL}${url}`, {
    method: 'POST',
    body: formData,
    ...options,
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.message || 'Request error');
    error.response = {
      data,
      status: response.status,
    };
    throw error;
  }

  return {
    data,
  };
};

class Api {
  static register(data) {
    const formData = new FormData();

    formData.append('email', data.formData.email);
    formData.append('password', data.formData.password);
    formData.append(
      'password_confirmation',
      data.formData.password_confirmation,
    );
    formData.append('lang', data.lang);

    data.localBasket.forEach((item, index) => {
      formData.append(`section_id[${index}]`, item.id);
    });

    return formRequest('/register', formData);
  }

  static login(data) {
    const formData = new FormData();

    formData.append('email', data.data.email);
    formData.append('password', data.data.password);
    formData.append('lang', data.lang);

    data.localBasket.forEach((item, index) => {
      formData.append(`section_id[${index}]`, item.id);
    });

    return formRequest('/login', formData);
  }

  static passwordRecovery(payload) {
    return request('/reset-password-request', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  static changeUserPassword(payload) {
    return request('/change-password-profile', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  static changeProfile(payload) {
    return request('/change-profile', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  static resetPassword(payload) {
    return request('/change-password', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  static getHomePage() {
    return request('/get-home-data');
  }

  static getAboutUsPage() {
    return request('/get-about-data');
  }

  static getLaboratoryPage() {
    return request('/get-laboratory-data');
  }

  static getComprehensivePage() {
    return request('/comprehensive-studies');
  }

  static getCareerPage() {
    return request('/get-vacancies-data');
  }

  static sendCareerCv(payload, lang) {
    return request('/send-vacancies-cv', {
      method: 'POST',
      body: JSON.stringify({
        full_name: payload.full_name,
        vacancy_id: payload.vacancy_id,
        phone: payload.phone,
        email: payload.email,
        lang,
        cv: payload.cv,
      }),
    });
  }

  static getDiagnosticPage() {
    return request('/get-diagnosticCenter-data');
  }

  static getPartnersPage() {
    return request('/get-partners');
  }

  // test
  static getContactPage() {
    return request('/get-contact-data');
  }

  static getRedirectUrls() {
    return request('/get-urls');
  }

  static getHeader() {
    return request('/header-menu');
  }

  static getFooter() {
    return request('/footer-data');
  }

  static getTranslation() {
    return request('/translation');
  }

  static getBlogsPage() {
    return request('/get-news-data');
  }

  static sendFiatBack(data, type) {
    let typeToSend = type;

    if (type === 'question') {
      typeToSend = 'questions';
    }

    if (type === 'message') {
      return request('/feedback', {
        method: 'POST',
        body: JSON.stringify(data),
      });
    }

    return request(`/send-${typeToSend}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  static getPoints() {
    return request('/points', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  static getSocialLinks() {
    return request('/social-link');
  }

  static getPointsConditions() {
    return request('/get-point-price');
  }

  static checkOut(payload) {
    return request('/checkouts', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  static getUserHistory() {
    return request('/history', {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  static houseCall(data) {
    return request('/house-call', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  static getDoctorProfile(id) {
    return request(`/staff/${id}`);
  }

  static getAddressPage() {
    return request('/get-address-data');
  }

  static getService(slug, lang) {
    return request(`/services/${lang}/${slug}`);
  }

  static getSingleArticle(id) {
    return request(`/news/${id}`);
  }

  static getFaq() {
    return request('/get-faq-data');
  }

  static getNews(limit, sort) {
    return request(`/get-news-data?limit=${limit}&sort=${sort}`);
  }

  static getCertificatesPage() {
    return request('/get-certificates-data');
  }

  static getPrivacyPolicy() {
    return request('/get-privacy-policy-data');
  }

  static getSearchResults(query) {
    return request(`/search?term=${query}`);
  }

  static getStaff() {
    return request('/all-staff?hide_from_diagnostic=1');
  }

  static sendGiftCart(payload) {
    return request('/santa-present/buy', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }
}

export default Api;
